'use strict';

const mindmupProfile = require('./mindmup-profile');

module.exports = function cognitoMindMupProfile(cognitoApi, providerName, catchAndResolveFalse) {
	return cognitoApi.userProfile()
	.then((cognitoProfile) => {
		const userAttributes = cognitoProfile && cognitoProfile.userAttributes,
			licenseString = userAttributes && userAttributes['custom:mm-license'],
			email = userAttributes && userAttributes.email,
			profile = email && licenseString && mindmupProfile(providerName, email, JSON.parse(licenseString), cognitoProfile);
		return profile;
	})
	.catch((reason) => {
		if (catchAndResolveFalse) {
			return false;
		}
		throw reason;
	});

};
